<template>
    <div>
        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <div v-if="!isStatusRequested">
                <div>
                    <h3 class="fg-color-blue">Reset password request</h3>
                    <br />

                    <div class="form-group">
                        <label for="Email">Email:</label>
                        <input v-model="email" type="email" class="form-control">
                        <ValidationError context="Email" :errors="validationErrors"></ValidationError>
                    </div>
                    <br />

                    <button v-show="isStatusNotRequested" @click="handleRequestResetPasswordCommandV1" type="button" class="btn btn-primary btn-lg btn-block">Request</button>
                    <button v-show="isStatusRequesting" type="button" class="btn btn-primary btn-lg btn-block" disabled>Requesting...</button>
                </div>

                <br />

                <span>
                    <span>Already have an account?</span>
                    <a href="/#/signin">Sign-in</a>
                </span>
            </div>

            <div v-else>
                <h1>Your request was sent</h1>
                <h4>
                    If you have an active account in TransparentChoice then you will get an email with reset password link valid 24h.
                    Please use this link to set a new password.
                </h4>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/commands-vue-component";
    import "@common/Components/ValidationError.vue";

    enum Status {
        NotRequested,
        Requesting,
        Requested
    }

    @Component
    export default class RequestResetPasswordPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        email = '';
        status: Status = Status.NotRequested;

        get isStatusNotRequested() { return this.status == Status.NotRequested }
        get isStatusRequesting() { return this.status == Status.Requesting }
        get isStatusRequested() { return this.status == Status.Requested }

        mounted() {
            this.setTitle("Request reset password");
        }

        handleRequestResetPasswordCommandV1() {
            this.status = Status.Requesting;
            this.invokeRequestResetPasswordCommandV1(this.email);
        }

        succeedRequestResetPasswordCommandV1() {
            this.status = Status.Requested;
        }

        invalidRequestResetPasswordCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.status = Status.NotRequested;
        }

        failedRequestResetPasswordCommandV1() {
            this.status = Status.NotRequested;
        }
    }
</script>

<style scoped>
</style>